import React from 'react';
import { Label } from '@core/js/components/common/Fields/Label/Label';
import { ErrorMessage } from '@core/js/components/common/ErrorMessage';

import * as helpers from '@core/js/components/common/Fields/Control/helpers';

import style from './Control.scss';

// @theme
import { clsb } from '@core/js/utils/classNames.util';

export const Control = ({
    id,
    meta: { active, touched, submitting, validating, submitError, error = submitError, customError } = {},
    label,
    hint,
    readOnly,
    classNames = {},
    className = '',
    onClick,
    animate,
    children,
    bottomHint,
    disabled = false,
    isBorderHidden = false,
    infoTooltip = '',
    isLabelAsteriskEnabled = false,
    // #region @theme
    labelClass,
    controlClass,
    // #endregion
    ...props // data attributes
}) => {
    const modeClassName = helpers.getModeClass({
        error: customError || error, touched,
        active, submitting, validating, disabled, readOnly
    });
    // #region @theme
    const formControlStyle = controlClass ? modeClassName : '';
    const controlClassName = clsb([style, classNames], ['control', formControlStyle]);
    // #endregion
    return (
        <div
            onClick={onClick}
            className={`${controlClassName} ${isBorderHidden ? style.hideBorder : ''} ${className} ${controlClass ? `${controlClass?.control} control-${modeClassName}` : ''}`} // @theme
        >
            {(label || isLabelAsteriskEnabled) && (
                <Label
                    id={id}
                    hint={hint}
                    label={label}
                    readOnly={readOnly}
                    classNames={labelClass} // @theme
                    infoTooltip={infoTooltip}
                    isLabelAsteriskEnabled={isLabelAsteriskEnabled}
                />
            )}

            <div
                // @theme className
                className={`${clsb([style, classNames], ['content'])} cms-control-content ${controlClass ? controlClass?.controlContent : ''}`}
                {...props}
            >
                {children}
            </div>

            {bottomHint && (
                <span className={`${clsb(['bottomHint'], style, classNames)}`}>{bottomHint}</span>
            )}

            {(error && touched && !active && !validating || customError) && (
                <ErrorMessage
                    error={customError || error}
                    animate={animate}
                    classNames={{ error: style.error, ...classNames }}
                />
            )}
        </div>
    );
};
